function asyncSleep(timeout) {
  return new Promise(resolve => {
    setTimeout(resolve, timeout);
  });
}

export default asyncSleep;
